import axios from '@/axios'

const state = {
    envelopeType: {},
};

const getters = {
    getEnvelopeType: (state) => state.envelopeType,
};

const mutations = {
    setEnvelopeType: (state, envelopeType) => (state.envelopeType = envelopeType),
};

const actions = {
    async loadEnvelopeType(context, data) {
        await axios().get(`/getEnvelopeType`)
            .then(response => {
                context.commit('setEnvelopeType', response.data)
            })
    },
    async envelopeTypeDeleteItem(context, item) {
        await axios().post(`/deleteEnvelopeType/${item.id}`)
    },
    async envelopeTypeUpdateItem(context, item) {
        await axios().post(`/updateEnvelopeType/${item.id}`, item)
    },
    async envelopeTypeAddItem(context, item) {
        await axios().post(`/addEnvelopeType`, item)
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
